export const FASTLY_ZIP_HEADER = 'client-geo-postal-code'
export const INFERRED_ZIP = 'inferred_zip'
export const INFERRED_ZIP_SRC = 'inferred_zip_src'
